import { motion } from 'framer-motion';
import { Star } from 'lucide-react';

const testimonials = [
  {
    name: 'Chidi E.',
    location: 'Lagos, Nigeria',
    text: 'I used to spend 3 hours on one flyer. Now I open a template, change the text and photo, and I\'m done in 10 minutes. My clients think I hired a whole team.',
  },
  {
    name: 'Ama D.',
    location: 'Accra, Ghana',
    text: 'The mockups alone are worth it. I use them for my product photos on Instagram. My page went from basic to premium-looking overnight.',
  },
  {
    name: 'Brian K.',
    location: 'Nairobi, Kenya',
    text: 'I run a small design business and these templates saved my life. I now deliver faster and my clients always come back. Best money I\'ve spent.',
  },
];

const styles = {
  section: {
    padding: '100px 20px',
    background: '#fafafa',
  },
  container: {
    maxWidth: '1100px',
    margin: '0 auto',
  },
  heading: {
    textAlign: 'center',
    fontSize: 'clamp(1.8rem, 4vw, 2.5rem)',
    fontWeight: 800,
    color: '#0f172a',
    marginBottom: '60px',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '24px',
  },
  card: {
    padding: '32px',
    borderRadius: '16px',
    background: '#ffffff',
    border: '1px solid #e2e8f0',
  },
  stars: {
    display: 'flex',
    gap: '4px',
    marginBottom: '16px',
  },
  text: {
    fontSize: '1rem',
    color: '#374151',
    lineHeight: 1.7,
    marginBottom: '20px',
    fontStyle: 'italic',
  },
  name: {
    fontSize: '0.95rem',
    fontWeight: 700,
    color: '#0f172a',
  },
  location: {
    fontSize: '0.85rem',
    color: '#94a3b8',
  },
};

function Testimonials() {
  return (
    <section style={styles.section}>
      <div style={styles.container}>
        <h2 style={styles.heading}>What People Are Saying</h2>
        <div style={styles.grid}>
          {testimonials.map((t, index) => (
            <motion.div
              key={index}
              style={styles.card}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
            >
              <div style={styles.stars}>
                {[...Array(5)].map((_, i) => (
                  <Star key={i} size={18} fill="#08F654" color="#08F654" />
                ))}
              </div>
              <p style={styles.text}>"{t.text}"</p>
              <p style={styles.name}>{t.name}</p>
              <p style={styles.location}>{t.location}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Testimonials;
